import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PlayFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0766 4.35391L7.15764 2.8727C5.12668 1.84209 4.11121 1.32678 3.3891 1.91308C2.66699 2.49937 2.66699 3.83917 2.66699 6.51875V9.48117C2.66699 12.1608 2.66699 13.5005 3.3891 14.0868C4.11121 14.6731 5.12668 14.1578 7.15764 13.1272L10.0766 11.646C13.1368 10.0931 14.667 9.31659 14.667 7.99996C14.667 6.68333 13.1368 5.90685 10.0766 4.35391Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const PlayFilledSize16 = hoc(forwardRef(PlayFilledSize16Component), 'PlayFilledSize16');

export { PlayFilledSize16 as default };
//# sourceMappingURL=PlayFilledSize16.js.map
